'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'party-horn';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e31b';
var svgPathData = ['M37.4 472.1l25.8-66.3 43 43L39.9 474.6l-2.5-2.5zm38.5-98.9l18.7-48.1 92.3 92.3-48.1 18.7L75.9 373.2zm31.5-80.5c5.5-14.5 11.1-29 16.7-43.4L262.7 388c-14.4 5.6-28.9 11.2-43.4 16.7l-112-112z', 'M88 32A24 24 0 1 0 40 32a24 24 0 1 0 48 0zM504 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM480 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM161.4 136L184 158.6l11.3-11.3 8.3-8.3c23.1-23.1 37.7-53.4 41.3-85.9l3-27.4 1.8-15.9L217.9 6.3l-1.8 15.9-3 27.4c-2.8 25.3-14.1 48.8-32.1 66.8l-8.3 8.3L161.4 136zM364.7 316.7L353.4 328 376 350.6l11.3-11.3 8.2-8.3c18-18 41.6-29.3 66.8-32.1l27.4-3 15.9-1.8-3.5-31.8-15.9 1.8-27.4 3c-32.5 3.6-62.8 18.2-85.9 41.3l-8.3 8.3zM510.6 25.9L489.9 1.5 477.7 11.8l-10 8.5c-7.3 6.2-16.6 9.4-26.1 9.2c-38.2-1-70.4 28.5-72.6 66.6l-1.8 30c-1.2 20.9-18.8 37.1-39.8 36.5l-16-.4 0 1.8c-11.6 2.4-22.5 7.6-31.6 15.3l-10 8.5-12.2 10.3 20.7 24.4 12.2-10.3 10-8.5c7.3-6.2 16.6-9.4 26.1-9.2c38.2 1 70.4-28.5 72.6-66.6l1.8-30c1.2-20.9 18.8-37.1 39.8-36.5c17.4 .5 34.4-5.5 47.7-16.7l10-8.5 12.2-10.3zM39.9 474.6l-2.5-2.5 25.8-66.3 43 43L39.9 474.6zm147-57.2l-48.1 18.7L75.9 373.2l18.7-48.1 92.3 92.3zM107.3 292.7l-.1-.1L124 249.3 262.7 388l-43.3 16.8-.1-.1-112-112zm-8-68.1L0 480l32 32 255.4-99.3L320 400l-24.7-24.7L136.7 216.7 112 192 99.3 224.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPartyHorn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;